import {
  AggregateDataverseChartDataSource,
  QueryAggregate,
  DateGrouping,
  ChartType,
  type ChartClickEventArgs,
} from '@powerportalspro/react-charts';
import { DataverseChart } from '@powerportalspro/react-fluent';
import { useT } from '@powerportalspro/react';
import { useMemo, useState } from 'react';

const STRINGS_BASE =
  'components.PowerPortalsPro.Demo.Client.Customizations.Pages.Charts.BarChart.BarChartViewDemo';

// Opportunity views the dropdown lists. The chart reloads with the
// selected view's filter conditions each time. Same view ids the Blazor
// demo uses, so both stacks read the same view list.
const WON_OPPORTUNITIES_VIEW_ID = 'f73a5bef-a782-de11-9ff3-00155da3b012';
const ALL_OPPORTUNITIES_VIEW_ID = 'c6f6fc1b-1b3e-e711-80e1-00155d871bb4';
const VIEW_IDS = [WON_OPPORTUNITIES_VIEW_ID, ALL_OPPORTUNITIES_VIEW_ID];

export function BarChartViewSample() {
  const t = useT();
  const [lastClick, setLastClick] = useState<ChartClickEventArgs | null>(null);
  const source = useMemo(
    () =>
      new AggregateDataverseChartDataSource({
        tableName: 'opportunity',
        groupByColumn: 'actualclosedate',
        groupByDateGrouping: DateGrouping.Month,
        aggregateColumn: 'estimatedvalue',
        aggregate: QueryAggregate.Sum,
        singleSeriesLabel: t(`${STRINGS_BASE}.series-label`),
      }),
    [t],
  );
  return (
    <>
      <DataverseChart
        dataSource={source}
        type={ChartType.Bar}
        title={t(`${STRINGS_BASE}.chart-title`)}
        yAxisPrefix="$"
        viewIds={VIEW_IDS}
        defaultViewId={WON_OPPORTUNITIES_VIEW_ID}
        onElementClick={setLastClick}
      />
      {lastClick && (
        <p style={{ marginTop: '12px' }}>
          <strong>{t(`${STRINGS_BASE}.clicked-label`)}:</strong>{' '}
          {lastClick.label} — ${lastClick.value.toLocaleString()}
        </p>
      )}
    </>
  );
}
